export const API_NAME = "servingUnit";
export const ROUTE_NAME = "servingUnit";
export const COMPONENT_NAMES = ["Serving Unit", "Serving Units"];
